var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"flex space-x-4 max-w-full",attrs:{"aria-label":"Tabs"}},_vm._l((_vm.tabs),function(tab){return _c('a',{key:tab.label,class:[
        tab.isRefined
          ? 'bg-primary text-white'
          : 'text-gray-500 hover:text-gray-700',
        'px-1 py-2 font-medium text-sm rounded-md' ],attrs:{"href":_vm.createURL(tab.value),"aria-current":tab.current ? 'page' : undefined},on:{"click":function($event){$event.preventDefault();return _vm.refine(tab.value)}}},[_vm._v(" "+_vm._s(tab.label)+" ("+_vm._s(tab.count)+") ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }